export default "__VITE_ASSET__CyO3$nhI__"